import { FC } from 'react';
import { Box } from '@material-ui/core';
import { CustomLogoProps } from './types';

import poweredByHorizontal from './powered-by-witboost_horiz.svg';
import { useWbSidebarMobileState } from '../../WbNavbarMobileStateContext';

interface Props {
  customLogo: CustomLogoProps;
  hidePoweredBy?: boolean;
}

export const CustomLogo: FC<Props> = ({ customLogo, hidePoweredBy }) => {
  const { isMobile } = useWbSidebarMobileState();
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: hidePoweredBy ? 'flex-start' : 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        gap: '4px',
        padding: isMobile ? '4px 8px' : '4px 16px',
      }}
    >
      <img
        style={{
          maxHeight: hidePoweredBy ? '100%' : 'calc(100% - 16px - 4px)',
          maxWidth: '100%',
        }}
        src={customLogo.url}
        alt="custom logo"
      />
      {!hidePoweredBy && (
        <img
          style={{ height: '16px' }}
          src={poweredByHorizontal}
          alt="powered by witboost"
        />
      )}
    </Box>
  );
};

// export const CustomLogo: FC<Props> = ({ customLogo, hidePoweredBy }) => {
//   return <ColumnLogo customLogo={customLogo} hidePoweredBy={hidePoweredBy} />;
// };
